import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/appShell.js";
import { RequireAuth, RequirePermission } from "./components/guards.js";
import { AuditTrailPage } from "./pages/auditTrailPage.js";
import { CatalogPage } from "./pages/catalogPage.js";
import { CustomersPage } from "./pages/customersPage.js";
import { CustomerDetailPage } from "./pages/customerDetailPage.js";
import { DashboardPage } from "./pages/dashboardPage.js";
import { DocumentsPage } from "./pages/documentsPage.js";
import { JobsPage } from "./pages/jobsPage.js";
import { JobCreatePage } from "./pages/jobCreatePage.js";
import { JobDetailPage } from "./pages/jobDetailPage.js";
import { LoginPage } from "./pages/loginPage.js";
import { InvoicesPage } from "./pages/invoicesPage.js";
import { ImportsPage } from "./pages/importsPage.js";
import { ReportsPage } from "./pages/reportsPage.js";
import { MaterialsPage } from "./pages/materialsPage.js";
import { PurchasingPage } from "./pages/purchasingPage.js";
import { NotFoundPage } from "./pages/notFoundPage.js";
import { PlaceholderPage } from "./pages/placeholderPage.js";
import { QuoteDetailPage } from "./pages/quoteDetailPage.js";
import { QuotesPage } from "./pages/quotesPage.js";
import { RfqsPage } from "./pages/rfqsPage.js";
import { SalesOrdersPage } from "./pages/salesOrdersPage.js";
import { ShopFloorPage } from "./pages/shopFloorPage.js";
import { UsersPage } from "./pages/usersPage.js";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route
            path="customers"
            element={
              <RequirePermission permission="customers:read">
                <CustomersPage />
              </RequirePermission>
            }
          />
          <Route
            path="customers/:id"
            element={
              <RequirePermission permission="customers:read">
                <CustomerDetailPage />
              </RequirePermission>
            }
          />
          <Route
            path="quotes"
            element={
              <RequirePermission permission="quotes:manage">
                <QuotesPage />
              </RequirePermission>
            }
          />
          <Route
            path="quotes/:id"
            element={
              <RequirePermission permission="quotes:manage">
                <QuoteDetailPage />
              </RequirePermission>
            }
          />
          <Route
            path="rfqs"
            element={
              <RequirePermission permission="quotes:manage">
                <RfqsPage />
              </RequirePermission>
            }
          />
          <Route
            path="sales-orders"
            element={
              <RequirePermission permission="quotes:manage">
                <SalesOrdersPage />
              </RequirePermission>
            }
          />
          <Route
            path="catalog"
            element={
              <RequirePermission permission="quotes:manage">
                <CatalogPage />
              </RequirePermission>
            }
          />
          <Route
            path="jobs"
            element={
              <RequirePermission permission="jobs:manage">
                <JobsPage />
              </RequirePermission>
            }
          />
          <Route
            path="jobs/new"
            element={
              <RequirePermission permission="jobs:manage">
                <JobCreatePage />
              </RequirePermission>
            }
          />
          <Route
            path="jobs/:id"
            element={
              <RequirePermission permission="jobs:manage">
                <JobDetailPage />
              </RequirePermission>
            }
          />
          <Route
            path="shop-floor"
            element={
              <RequirePermission permission="shopfloor:view">
                <ShopFloorPage />
              </RequirePermission>
            }
          />
          <Route
            path="materials"
            element={
              <RequirePermission permission="purchasing:manage">
                <MaterialsPage />
              </RequirePermission>
            }
          />
          <Route
            path="purchasing"
            element={
              <RequirePermission permission="purchasing:manage">
                <PurchasingPage />
              </RequirePermission>
            }
          />
          <Route
            path="invoices"
            element={
              <RequirePermission permission="finance:manage">
                <InvoicesPage />
              </RequirePermission>
            }
          />
          <Route
            path="reports"
            element={
              <RequirePermission permission="reports:ops">
                <ReportsPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/imports"
            element={
              <RequirePermission permission="settings:manage">
                <ImportsPage />
              </RequirePermission>
            }
          />
          <Route
            path="documents"
            element={
              <RequirePermission permission="attachments:read">
                <DocumentsPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/users"
            element={
              <RequirePermission permission="users:manage">
                <UsersPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/audit-trail"
            element={
              <RequirePermission permission="audit:read">
                <AuditTrailPage />
              </RequirePermission>
            }
          />
          <Route
            path="settings"
            element={
              <RequirePermission permission="settings:manage">
                <PlaceholderPage
                  title="Settings"
                  slice="S8"
                  summary="Shop identity, numbering formats, work centers, expense categories, and role onboarding."
                />
              </RequirePermission>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
